/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface ManualDiscountDto
 */
export interface ManualDiscountDto {
  _id?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualDiscountDto
     */
    valueType: ManualDiscountDtoValueTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ManualDiscountDto
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof ManualDiscountDto
     */
    reason?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ManualDiscountDtoValueTypeEnum {
    PERCENTAGE = 'PERCENTAGE',
    FIXEDAMOUNT = 'FIXED_AMOUNT'
}

